import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { STATUS_META, SLA_META } from "@/lib/labels";

const STATUS_DESC = {
  CONCILIADO: "Coincide en ambos archivos sin discrepancias.",
  DIFERENCIA: "Coincide, pero difiere en fecha, estatus o cantidad.",
  PENDIENTE_STORIS: "Está en el Reporte (TE331) pero no en la Vista actual (TE325).",
  EXISTE_UI_NO_REPORTE: "Está en la Vista actual (TE325) pero no en el Reporte (TE331).",
  DATOS_INCOMPLETOS: "Falta Order #, Modelo o la fecha es inválida para poder cruzar.",
};
const STATUS_ORDER = ["CONCILIADO", "DIFERENCIA", "PENDIENTE_STORIS", "EXISTE_UI_NO_REPORTE", "DATOS_INCOMPLETOS"];

const SLA_DESC = {
  EN_SLA: "Dentro del plazo de entrega.",
  EN_RIESGO: "Próximo a vencer (ventana de riesgo).",
  FUERA_SLA: "Vencido o atrasado.",
};
const SLA_ORDER = ["EN_SLA", "EN_RIESGO", "FUERA_SLA"];

function Swatch({ meta, desc }) {
  return (
    <div className="flex items-start gap-2.5">
      <span
        className="mt-0.5 inline-flex items-center rounded-sm font-semibold whitespace-nowrap border px-2 py-0.5 text-[11px] shrink-0"
        style={{ background: meta.bg, color: meta.text, borderColor: meta.border }}
      >
        {meta.label}
      </span>
      <span className="text-[13px] leading-snug text-slate-600">{desc}</span>
    </div>
  );
}

export function StatusLegend() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" data-testid="status-legend-trigger"
          className="h-8 rounded-sm border-slate-300 text-slate-600 gap-1.5">
          <Info size={14} /> Leyenda
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[360px] rounded-sm p-4" data-testid="status-legend-content">
        <div className="text-[11px] uppercase tracking-[0.06em] font-semibold text-slate-500 mb-2">
          Estatus de conciliación
        </div>
        <div className="space-y-2.5">
          {STATUS_ORDER.map((c) => (
            <Swatch key={c} meta={STATUS_META[c]} desc={STATUS_DESC[c]} />
          ))}
        </div>
        <div className="mt-3 pt-3 border-t border-slate-100 text-[12px] text-slate-500 leading-snug">
          En una <strong>Diferencia</strong>, el badge indica el motivo
          (<span className="text-slate-700">· Fecha / Estatus / Cantidad</span>).
        </div>

        <div className="text-[11px] uppercase tracking-[0.06em] font-semibold text-slate-500 mt-4 mb-2">
          SLA
        </div>
        <div className="space-y-2.5">
          {SLA_ORDER.map((c) => (
            <Swatch key={c} meta={SLA_META[c]} desc={SLA_DESC[c]} />
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
